var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsUUID } from 'class-validator';
import { Icd10SlimDto } from '../../anamnesis/dtos/icd10.slim.dto.js';
import { UserProfileDto } from './user.profile.dto.js';
export class UserIcd10FullSizeDto {
    id;
    createdAt;
    updatedAt;
    user;
    userId;
    icd10;
    icd10Id;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserIcd10FullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], UserIcd10FullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], UserIcd10FullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], UserIcd10FullSizeDto.prototype, "user", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserIcd10FullSizeDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => Icd10SlimDto),
    __metadata("design:type", Function)
], UserIcd10FullSizeDto.prototype, "icd10", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserIcd10FullSizeDto.prototype, "icd10Id", void 0);
//# sourceMappingURL=user-icd10.full-size.dto.js.map